import { ModelMenuRefreshEventsMap } from '@src/slide/domain/ui-model/element-modeles/Interface/model-menu-refresh.interface';

export enum MenuManagerEventsKeys {
    'ENTER_LINK_EDIT' = 'enterLinkEdit',
    'ENTER_ELEMENT' = 'enterElement',
    'LEAVE_ELEMENT' = 'leaveElement',
    'LINK_CLICK' = 'linkClick'
}

export interface MenuManagerEventsMap extends ModelMenuRefreshEventsMap {
    [MenuManagerEventsKeys.ENTER_LINK_EDIT]: void;
    [MenuManagerEventsKeys.ENTER_ELEMENT]: number | string;
    [MenuManagerEventsKeys.LEAVE_ELEMENT]: number | string;
    [MenuManagerEventsKeys.LINK_CLICK]: number | string;
}
